export default {"src":"/_next/static/media/nkn.c468f1fc.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};